/**
 * 【配送单评价页】
 */
import React from 'react';
import TableContent from './components/TableContent';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import moment from 'moment';
import { SearchBox, SearchItem } from '@/components/Layout';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import model from '@/reducers/aftersale/deliveryeval/model';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { XInput, XOKButton, XCancelButton, XDatePicker, XSelect, XScrollSelect, XInputNum } from '@/components/xqxc_ui';

class Main extends React.Component {
    state = {
        compare: {},
        startTime: undefined,
        endTime: undefined,
    }

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
        this.props.getfindStars(); // 星级
        const { tel } = this.props.match.params || {};
        if (tel) {
            this.setState({ riderPhone: tel });
        }
    }

    // 表格操作
    _tableAction = (key, type, record) => {
        const { history } = this.props;
        switch (type) {
            // 查看详情
            case 'info':
                history.push({
                    pathname: `/home/aftersale/deliveryeval/orderdetail/${record.id}`,
                });
                break;
        }
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    // 查询
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, startTime, endTime, orderId, riderPhone, userTel, compare } = this.state;
        const query = {
            riderPhone,
            userTel,
            orderId,
            startTime,
            endTime,
            starId: compare.id,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getlistAppraiseInfo(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置
    _resetHandle = () => {
        this.setState({ startTime: undefined, endTime: undefined, riderPhone: '', orderId: '', userTel: '', compare: {}, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }
    startDate = () => {
        this.setState({ endTime: undefined });
    }
    disabledDate = (current) => {
        const { startTime } = this.state;
        let enddays = startTime && moment(startTime);
        return current && current < enddays && enddays.startOf('day');
    }
    orderIdHandle = e => {
        var value = e.target.value;
        const reg = /^[0-9a-zA-Z]*$/; // 数字、字母
        if (value && value.toString().length > 21) {
            return;
        } else if (!reg.test(value)) {
          this.setState({ orderId: undefined });
        }
    }
    render() {
        const { listAppraiseInfo, findStars } = this.props;
        const { riderPhone, orderId, userTel, startTime, endTime, compare } = this.state;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={`${styles.flexBoxContainer} ${styles.deliveryeval}`}>
                    <SearchBox>
                        <SearchItem>
                            <XInputNum
                                label='骑士账号'
                                placeholder='请输入骑士账号'
                                value={riderPhone}
                                bindThis={this}
                                bindName='riderPhone'
                                min={0}
                                precision={0}
                                maxLength={11}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                label='订单编号'
                                placeholder='请输入订单编号'
                                value={orderId}
                                bindThis={this}
                                bindName='orderId'
                                // min={0}
                                // precision={0}
                                maxLength={21}
                                onBlur={this.orderIdHandle}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInputNum
                                label='用户账号'
                                placeholder='请输入用户账号'
                                value={userTel}
                                bindThis={this}
                                bindName='userTel'
                                min={0}
                                precision={0}
                                maxLength={16}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                style={{ marginRight: 20 }}
                                selectStyle={{ width: 100 }}
                                label='星级'
                                placeholder='请选择'
                                renderData={findStars}
                                dataIndex='name'
                                keyIndex='id'
                                value={compare.name}
                                showSearch={true}
                                bindThis={this}
                                bindName='compare'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='送达时间'
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                isFormat
                                showTime={false}
                                defaultTime='00:00:00'
                                onChange={this.startDate}
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                isFormat
                                showTime={false}
                                defaultTime='23:59:59'
                                disabledDate={this.disabledDate}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableContent renderData={listAppraiseInfo} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                </div>
            </KeepAlive >
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,
    getlistAppraiseInfo: PropTypes.func,
    listAppraiseInfo: PropTypes.object,
    getfindStars: PropTypes.func,
    findStars: PropTypes.array
};

const mapStateToProps = (state) => ({
    listAppraiseInfo: state.deliveryeval.listAppraiseInfo,
    findStars: state.deliveryeval.findStars,
});

export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);
